/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * The status of card account.
 */
export type CardAccountStatus = typeof CardAccountStatus[keyof typeof CardAccountStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardAccountStatus = {
  active: 'active',
  frozen: 'frozen',
} as const;
